import { useCallback } from 'react';
import { useConnectedAccount } from 'features/invest/hooks/selectors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
export const useDepositToPot = (pot) => {
    const navigation = useMainStackNavigation();
    const connectedAccount = useConnectedAccount();
    const handleDeposit = useCallback(() => {
        if (connectedAccount) {
            navigation.navigate('DepositToPotScreen', { pot });
        }
        else {
            navigation.navigate('SelectFundingAccount', {
                pot,
            });
        }
    }, [connectedAccount, pot]);
    return handleDeposit;
};
export default useDepositToPot;
